export * from '@sportworld/js-sdk/src/constants/common'
import Hls, { HlsConfig, LoadPolicy } from 'hls.js'

import { commonDefaultAppConfig } from '@sportworld/js-sdk/src/constants/common'
import { RootDomains, b1RootDomain } from '@sportworld/js-sdk/src/envs/envs'

import { AppSettingsType, ConfigType } from '@/types/servicesTypes/configTypes'

export const usercentricsSettingsId =
  import.meta.env.REACT_APP_USERCENTRICS_SETTINGS_ID || ''

const getEnvironment = () => {
  if (b1RootDomain === RootDomains.dev) {
    return 'dev'
  } else if (b1RootDomain === RootDomains.test) {
    return 'test'
  } else {
    return ''
  }
}

export const env = getEnvironment()

const extendPolicy = (policy: LoadPolicy, maxNumRetry: number): LoadPolicy => {
  return {
    ...policy,
    default: {
      ...policy.default,
      errorRetry: {
        ...(policy.default.errorRetry || {
          maxNumRetry: 1,
          retryDelayMs: 1000,
          maxRetryDelayMs: 8000,
        }),
        maxNumRetry,
      },
    },
  }
}
/**
 * HLS.js retries every 8 seconds (maxRetryDelayMs), up to 10 hours
 */
const UP_TO_TEN_HOURS_OF_RETRIES = (10 * 60 * 60) / 8
const hlsOptions: Partial<HlsConfig> = {
  debug: false,
  capLevelToPlayerSize: true,
  maxFragLookUpTolerance: 0,
  backBufferLength: 10,
  maxBufferLength: 30,
  maxMaxBufferLength: 30,
  maxLoadingDelay: 4,
  fragLoadPolicy: extendPolicy(
    Hls.DefaultConfig.fragLoadPolicy,
    UP_TO_TEN_HOURS_OF_RETRIES,
  ),
  manifestLoadPolicy: extendPolicy(
    Hls.DefaultConfig.manifestLoadPolicy,
    UP_TO_TEN_HOURS_OF_RETRIES,
  ),
  keyLoadPolicy: extendPolicy(
    Hls.DefaultConfig.keyLoadPolicy,
    UP_TO_TEN_HOURS_OF_RETRIES,
  ),
  playlistLoadPolicy: extendPolicy(
    Hls.DefaultConfig.playlistLoadPolicy,
    UP_TO_TEN_HOURS_OF_RETRIES,
  ),
}

export const defaultAppConfig: ConfigType = {
  ...commonDefaultAppConfig,
  limitTilesPerLine: 10,
  channelEventsLimit: 5,
  hlsOptions,
}

export const defaultAppSettings: Partial<AppSettingsType> = {
  isCustomPaletteUsed: false,
  isDevToolsUsed: false,
  isPerformanceMonitorUsed: false,
  isDisabledBlur: true,
  isDisabledImages: false,
  isDisabledHtmlWidgets: false,
  isDisabledLines: false,
  isDisabledStageAutoslide: false,
  isEnabledImaSdk: true,
  isEnabledImaSdkDebug: false,
  isEnabledChannelEventMockData: false,
}

export enum eventStatus {
  IS_LIVE = 'isLive',
  IS_PAST = 'isPast',
  IS_FUTURE = 'isFuture',
}

export enum VideoPlaybackStatus {
  ERROR,
  STARTED,
  ENDED,
}

export enum FirebaseRemoteConfigFlag {
  DIRECT_PURCHASE_ENABLED = 'direct_purchase_enabled',
  FORCE_UPDATE_VERSION = 'force_update_version',
  USER_CONSENT_ENABLED = 'user_consent_enabled',
}

export const overrideRegionIds = ['austria', 'germany', 'spain']

export const YOUTUBE_VIDEO_ID_PREFIX = 'youtube$'
